<template>
  <transition name="res-fade">
    <div
      v-if="visible"
      class="res-loader"
      :class="{ showbar }"
      :style="{ backgroundImage: `url(${loadingBg})` }"
    >
      <div class="res-center">
        <div class="res-bar">
          <div class="res-fill" :style="{ width: `${percent}%` }" />
        </div>
        <p class="res-text">游戏资源加载{{ percent }}%</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import loadingBg from '@/assets/lobby/ui/loading-bg.svg'
import { shouldPlayBootLoader } from '@/composables/bootLoader'

const visible = ref(shouldPlayBootLoader())
const showbar = ref(false)
const percent = ref(0)

let barTimer
let tickTimer
let hideTimer
let fadeTimer

const stopTimers = () => {
  clearTimeout(barTimer)
  clearInterval(tickTimer)
  clearTimeout(hideTimer)
  clearTimeout(fadeTimer)
}

onMounted(() => {
  if (!visible.value) return
  document.body.style.overflow = 'hidden'
  barTimer = setTimeout(() => {
    showbar.value = true
    tickTimer = setInterval(() => {
      if (percent.value >= 100) {
        clearInterval(tickTimer)
        hideTimer = setTimeout(() => {
          visible.value = false
          fadeTimer = setTimeout(() => {
            document.body.style.overflow = ''
          }, 700)
        }, 280)
        return
      }
      const step = percent.value < 70 ? 3 : percent.value < 92 ? 2 : 1
      percent.value = Math.min(100, percent.value + step)
    }, 40)
  }, 280)
})

onUnmounted(() => {
  stopTimers()
  document.body.style.overflow = ''
})
</script>

<style scoped>
.res-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 400;
  width: 100%;
  max-width: 480px;
  height: 100%;
  margin: 0 auto;
  background-color: #e94340;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.res-center {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  width: 240px;
  margin: 0 auto;
  opacity: 0;
  transition: opacity 0.35s ease;
}

.res-loader.showbar .res-center {
  opacity: 1;
}

.res-bar {
  height: 12px;
  border-radius: 99px;
  background: #f57674;
  overflow: hidden;
}

.res-fill {
  height: 100%;
  width: 0;
  background: #fff;
  border-radius: 99px;
  transition: width 0.12s linear;
}

.res-text {
  margin: 18px 0 0;
  text-align: center;
  font-size: 15px;
  color: #fff;
  letter-spacing: 0.5px;
}

.res-fade-leave-active {
  transition: opacity 0.7s ease-out;
}

.res-fade-leave-to {
  opacity: 0;
}
</style>
